import type { Tuple3 } from '../constants';

class TrackView {
  track: Float64Array;
  itemSize = 3;
  _lng = 0;
  _lat = 1;
  _elevation = 2;

  constructor(track: Float64Array) {
    this.track = track;
  }

  static from(array: Array<Tuple3>): TrackView {
    const track = new Float64Array(array.length * 3);
    for (let i = 0; i < array.length; i++) {
      track[i * 3] = array[i][0];
      track[i * 3 + 1] = array[i][1];
      track[i * 3 + 2] = array[i][2];
    }
    return new TrackView(track);
  }

  size(): number {
    return this.track.length / this.itemSize;
  }

  toJSON(): Array<Tuple3> {
    const result = [];
    for (let i = 0; i < this.size(); i++) {
      result.push(this.get(i));
    }
    return result;
  }

  get(i: number, out?: Tuple3): Tuple3 {
    const result: Tuple3 = out == null ? [0, 0, 0] : out;
    result[0] = this.getLng(i);
    result[1] = this.getLat(i);
    result[2] = this.getElevation(i);
    return result;
  }

  getLng(i: number): number {
    return this.track[i * this.itemSize + this._lng];
  }
  getLat(i: number): number {
    return this.track[i * this.itemSize + this._lat];
  }
  getLngLat(i: number): [number, number] {
    return [this.getLng(i), this.getLat(i)];
  }

  getLngLatInterpolated(i: number): [number, number] {
    const loIdx = Math.floor(i);
    const hiIdx = loIdx + 1;
    const frac = i % 1;
    return [
      this.getLng(loIdx) * (1 - frac) + this.getLng(hiIdx) * frac,
      this.getLat(loIdx) * (1 - frac) + this.getLat(hiIdx) * frac,
    ];
  }
  getElevation(i: number): number {
    return this.track[i * this.itemSize + this._elevation];
  }
}
export default TrackView;
